import { loadView } from '@/router'
import accounts from './accounts'
import opportunities from './opportunities'
import todo from './todo'
import budgets from './budgets'
import pipes from './pipes'

export default [
  {
    path: 'sales',
    name: 'sales',
    component: loadView('Application/Sales'),
    redirect: {
      name: 'sales-dashboard'
    },
    children: [
      {
        path: 'dashboard',
        name: 'sales-dashboard',
        component: loadView('Application/Sales/Dashboard')
      },
      {
        path: 'feed',
        name: 'feed',
        component: loadView('Application/Feed')
      },
      ...accounts,
      ...opportunities,
      ...todo,
      ...budgets,
      ...pipes
    ]
  }
]
